interface AppExperienceIconProps {
  /** Edge length in px. Defaults to 24 to match the Figma export. */
  size?: number
  className?: string
  /** Accepted for parity with `lucide-react` icons (so this component is a
   *  drop-in replacement in icon-prop slots) but ignored — the stroke widths
   *  are baked into the design. */
  strokeWidth?: number | string
}

/**
 * Branded icon for the "App & Bedienung" TopNav tab in Preferences. A
 * pink-on-pink paint-splotch silhouette with three accent dots — intentionally
 * warmer than the neutral Lucide glyphs used elsewhere in the TopNav, so the
 * "experience" category reads as the playful section.
 *
 * Colors are baked in (`pink-100` fill, `pink-600` strokes) and don't follow
 * the theme palette — the icon is meant to stay branded across all themes.
 *
 * @example
 * <AppExperienceIcon size={24} />
 */
export function AppExperienceIcon({ size = 24, className }: AppExperienceIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M1.15039 12C1.15039 6.03056 6.03056 1.15039 12 1.15039C17.8344 1.15039 22.8115 5.4507 22.8418 10.835V10.8398C22.8418 14.3605 19.9568 17.2441 16.4365 17.2441H14.4268C14.3208 17.2423 14.2154 17.2621 14.1172 17.3018C14.0189 17.3415 13.9295 17.4006 13.8545 17.4756C13.7797 17.5504 13.7204 17.6392 13.6807 17.7373C13.641 17.8355 13.6213 17.941 13.623 18.0469C13.6231 18.0516 13.623 18.0568 13.623 18.0615C13.623 18.2641 13.6644 18.3934 13.7334 18.4932L13.8105 18.585L13.8467 18.623C14.2229 19.0476 14.4979 19.6407 14.498 20.3115C14.498 21.7015 13.4167 22.8496 12 22.8496C6.03056 22.8496 1.15039 17.9694 1.15039 12Z"
        fill="#FCE7F3"
        stroke="#DB2777"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 7C13.7761 7 14 6.77614 14 6.5C14 6.22386 13.7761 6 13.5 6C13.2239 6 13 6.22386 13 6.5C13 6.77614 13.2239 7 13.5 7Z"
        stroke="#DB2777"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 11C17.7761 11 18 10.7761 18 10.5C18 10.2239 17.7761 10 17.5 10C17.2239 10 17 10.2239 17 10.5C17 10.7761 17.2239 11 17.5 11Z"
        stroke="#DB2777"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 8C8.77614 8 9 7.77614 9 7.5C9 7.22386 8.77614 7 8.5 7C8.22386 7 8 7.22386 8 7.5C8 7.77614 8.22386 8 8.5 8Z"
        stroke="#DB2777"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 13C6.77614 13 7 12.7761 7 12.5C7 12.2239 6.77614 12 6.5 12C6.22386 12 6 12.2239 6 12.5C6 12.7761 6.22386 13 6.5 13Z"
        stroke="#DB2777"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
